function showHide(){
    if (document.querySelector('.property-arch__hide-map') !== null){
    const getButton = document.querySelector('.property-arch__hide-map');
    const getMenu = document.querySelector('.property-arch__right');

    function toogleHam(){
        getButton.classList.toggle('property-arch__hide-map_active');
        getMenu.classList.toggle('property-arch__right_active');
        if(getButton.classList.contains('property-arch__hide-map_active')){
            getButton.innerHTML = 'Show Map';
        }else{
            getButton.innerHTML = 'Hide Map';
        }
    }

    getButton.addEventListener('click', toogleHam, false);
    }
}

module.exports = showHide;